import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const TemplatesModule = lazy(loadModule);

export default TemplatesModule;
